
import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { History } from "lucide-react";
import PreviousReportModal from "../components/previous-report/PreviousReportModal";
import { useTranslation } from "react-i18next";
import { tField } from "../utils/i18nField";

interface PreviousReportButtonProps {
  element: {
    id: string;
    label?: string;
  };
}

const PreviousReportButton: React.FC<PreviousReportButtonProps> = ({ element }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      <Button 
        type="button"
        variant="outline" 
        onClick={() => setIsModalOpen(true)}
        className="flex w-full md:w-auto items-center justify-center gap-2"
      >
        <History className="h-4 w-4" />
        {element.label ? tField(t, element.label) : t('form.fields.previousReportButton')}
      </Button>
      
      <PreviousReportModal 
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
      />
    </div>
  );
};

export default PreviousReportButton;
